import {typographyUnits} from '../../foundations/typography'

export default {
    parts: [
        'container',
        'fomoContainer',
        'fomoLabel',
        'miniStack',
        'miniRow',
        'miniImage',
        'miniMetaStack',
        'miniMetaContentStack',
        'miniPriceBox',
        'unavailableBox',
        'unavailableText',
        'miniWishlistStack',
        'miniActionsStack',
        'mobilePrimaryActionBox',
        'regularStack',
        'regularRow',
        'regularImage',
        'regularContent',
        'regularMetaStack',
        'regularPriceBox',
        'regularQuantityBox',
        'mobileActionsStack',
        'desktopActionsStack',
        'promotionText',
        'finalSaleText'
    ],
    baseStyle: {
        container: {
            position: 'relative',
            minWidth: 0
        },
        miniStack: {
            align: 'flex-start',
            width: '100%'
        },
        miniRow: {
            width: 'full',
            alignItems: 'flex-start',
            backgroundColor: 'webTheme.layerDefault',
            minWidth: 0
        },
        miniImage: {
            width: '140px',
            height: '100%',
            mr: 3,
            ratio: 2 / 3
        },
        miniMetaStack: {
            spacing: 0,
            flex: 1,
            minWidth: 0,
            alignItems: 'flex-start',
            justifyContent: 'space-between'
        },
        miniMetaContentStack: {
            spacing: 0,
            minWidth: 0,
            width: '100%'
        },
        miniPriceBox: {
            height: '100%',
            mb: 3
        },
        unavailableBox: {
            background: 'webTheme.backgroundPrimaryBrand',
            display: 'flex',
            width: '249px',
            maxWidth: {base: '170px', lg: 'none'},
            padding: '8px 16px',
            alignItems: 'center',
            color: 'webTheme.supportWarning',
            my: 2
        },
        unavailableText: {
            textStyle: 'bodySmRegular'
        },
        miniWishlistStack: {
            alignItems: 'flex-start'
        },
        miniActionsStack: {
            direction: 'row',
            gap: 6,
            mt: 3.5
        },
        mobilePrimaryActionBox: {
            display: ['block', 'none', 'none', 'none'],
            w: 'full'
        },
        regularStack: {
            align: 'flex-start',
            width: '100%',
        },
        regularRow: {
            width: 'full',
            alignItems: 'stretch',
            backgroundColor: 'webTheme.layerDefault',
            minWidth: 0
        },
        regularImage: {
            width: {base: '140px', lg: '225px'},
            height: '100%',
            mr: {base: 3, lg: 4},
            ratio: 225 / 330
        },
        regularContent: {
            flex: 1,
            minWidth: 0,
            direction: {base: 'column', lg: 'row'},
            justifyContent: 'space-between',
            gap: {base: 3, lg: 8}
        },
        regularMetaStack: {
            spacing: 0,
            minWidth: 0,
            alignItems: 'flex-start'
        },
        regularPriceBox: {
            mt: 2,
            mb: 4,
            textStyle: 'labelXs'
        },
        regularQuantityBox: {
            mt: 4,
            mb: {base: 8, lg: 4}
        },
        mobileActionsStack: {
            display: {base: 'flex', lg: 'none'},
            direction: 'row',
            spacing: 3,
            alignItems: 'center',
            mt: 2
        },
        desktopActionsStack: {
            display: {base: 'none', lg: 'flex'},
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            lineHeight: 'normal',
            minW: 'max-content',
            gap: 6
        },
        promotionText: {
            textStyle: 'labelXs',
            _empty: {display: 'none'}
        },
        finalSaleText: {
            color: 'webTypo.textTertiary',
            textStyle: 'bodySmRegular',
            marginTop: {base: 2}
        },
        fomoContainer: {
            alignItems: 'center',
            justifyContent: 'flex-start',
            width: '100%',
            minH: '18px',
            mb: 4,
            gap: 0,
            p: 0
        },
        fomoLabel: {
            fontSize: typographyUnits.webXs,
            lineHeight: '18px',
            minH: '18px',
            fontWeight: 'medium',
            textTransform: 'uppercase',
            color: 'webTypo.textPrimary',
            whiteSpace: 'nowrap'
        }
    },
    variants: {
        orderReview: {
            miniStack: {
                gap: 0
            }
        }
    }
}
